import { requestApi } from '../util/network'

// 获取系统配置
export const getConfigList =
    () =>
      requestApi(
        '/index/getConfigList',
        'POST',
        {
        }
      )

//获取微信公众号信息
export const getWXConfigList =
    (url) =>
      requestApi(
        '/Wxauto/getWeixinInfo',
        'POST',
        {
        	'url':url
        }
      )
      
//传微信订阅返回的信息给后台
export const getresultWXConfig =
    (data,openid) =>
      requestApi(
        '/Wxauto/resultAppintment',
        'POST',
        {
        	'templateid':data,
        	'openid':openid
        }
      )    
      
//传微信订阅返回的信息给后台
export const getliveidcontent =
    (liveid) =>
      requestApi(
        '/Wxauto/getMember_reservation',
        'POST',
        {
        	'id':liveid
        }
      )       
